import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTable, useSortBy, useFilters } from 'react-table';
import { FaUser, FaEdit } from 'react-icons/fa';

import SearchFilter from '~/components/Table/Filters/SearchFilter';
import { ActionsContainer, Action } from './styles';
import history from '~/services/history';

export default function Table({ data }) {
  const columns = useMemo(() => {
    const defaultColumns = [
      {
        Header: 'ID',
        accessor: 'id',
        disableFilters: true,
        disableSortBy: true,
      },
      {
        Header: 'Name',
        accessor: 'fullName',
      },
      {
        Header: 'Phone',
        accessor: 'phoneNumber',
        disableSortBy: true,
        disableFilters: true,
      },
      {
        Header: 'Email',
        accessor: 'email',
        disableSortBy: true,
      },
      {
        Header: 'Created at',
        accessor: 'created_at',
        disableFilters: true,
      },
      {
        Header: 'Actions',
        accessor: item => (
          <ActionsContainer>
            <>
              <Action
                onClick={() =>
                  history.push({
                    pathname: '/client/edit',
                    state: { item },
                  })
                }
              >
                <FaEdit />
                <span>Edit</span>
              </Action>
            </>
            <Action
              onClick={() =>
                history.push({
                  pathname: `/client/${item.id}`,
                })
              }
            >
              <FaUser />
              <span>View</span>
            </Action>
          </ActionsContainer>
        ),
        disableFilters: true,
        disableSortBy: true,
      },
    ];
    return defaultColumns;
  }, []);
  const defaultColumn = React.useMemo(() => ({ Filter: SearchFilter }), []);
  const filterTypes = React.useMemo(
    () => ({
      status: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id];
          return rowValue !== undefined &&
            row.values[id].props !== undefined &&
            row.values[id].props.children !== undefined
            ? String(row.values[id].props.children)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      },
    }),
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      defaultColumn,
      filterTypes,
      data,
    },
    useFilters,
    useSortBy
  );
  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {column.isSorted ? (
                    <span>{column.isSortedDesc ? ' ↓' : ' ↑'}</span>
                  ) : (
                    ' '
                  )}
                  {column.canFilter && <div> {column.render('Filter')} </div>}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};
